// Formats a raw status/phase token into a human, AWS-console-style label:
// "in_progress" -> "In Progress", "provisioned" -> "Provisioned",
// "partial_failure" -> "Partial Failure", "ACTIVE" -> "Active".
//
// Splits on underscores/hyphens/whitespace and upper-cases the first letter of
// each word (lower-casing the rest so all-caps AWS values read as Title Case).
// This mirrors the per-page statusLabels maps the CloudTrail portal already
// uses, so status chips look consistent across every org-service.
// A few tokens read better with a hand-written label than the mechanical
// Title-Case (e.g. CloudTrail's "escalating" phase means "assuming the role in
// the target account", so it shows "Accessing Account" rather than "Escalating").
const LABEL_OVERRIDES = {
  escalating: 'Accessing Account',
};

export function formatStatusLabel(status) {
  if (status === null || status === undefined || status === '') return '';
  const override = LABEL_OVERRIDES[String(status).toLowerCase()];
  if (override) return override;
  return String(status)
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
